module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("File Search Results")]), _vm._v(" "), _c('h4', [_vm._v("Projects")]), _vm._v(" "), _c('h4', [_vm._v("Cultural Resources")]), _vm._v(" "), _c('h4', [_vm._v("Isolated Finds")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae8d5582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FileSearchResults.vue
// module id = 985
// module chunks = 1